module.exports = __webpack_public_path__ + "static/media/reminder.c49722ec.mp3";